import './Music.css';
import React,{useContext, useEffect, useState} from 'react';

import {ContextGlobal} from '../globalProvider';

const Music = () => {
    const {state, dispatch} = useContext(ContextGlobal);

    const soundElement = document.getElementById('ambientSound');
    const [display, setDisplay] = useState({});

    useEffect(
        () => {
            if(soundElement !== null){
                if(state.sound){
                    soundElement.play();
                }else{
                    soundElement.pause();
                }
            }
        },
        [state.sound,soundElement]
    );

    return (
        <div>
            <audio id="ambientSound" src="/app/infocovidmais/songs/trilha.wav" preload="auto" loop></audio>
            <div className='audio column centerItens spaceAroundContent' style={display}>
                <div className = 'permission column centerItens '>
                    <span className = 'colorEIC3 title centerText'>Deseja habilitar a música</span>
                    <div className = 'answer row nowrap spaceAroundContent'>
                        <button className = 'backgroundEIC3' onClick = {()=>{dispatch({type:'UpdateSound'}); setDisplay({display:"none"})}}>Sim</button>
                        <button className = 'backgroundEIC3' onClick = {()=>{setDisplay({display:"none"})}}>Não</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Music;
